import { ReactNode } from 'react';
import { Typography } from 'antd';
import { BulbOutlined, CheckCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { FeatureGuideSection } from '../types';

// The three sections every feature guide is built from - kept here so guides stay copy-only.

export const whatItIs = (content: ReactNode): FeatureGuideSection => ({
    title: 'What it is?',
    icon: <QuestionCircleOutlined />,
    content: <Typography>{content}</Typography>,
});

export const howItHelps = (content: ReactNode): FeatureGuideSection => ({
    title: 'How it helps you?',
    icon: <CheckCircleOutlined />,
    content: <Typography>{content}</Typography>,
});

export const tips = (tips: ReactNode[]): FeatureGuideSection => ({
    title: 'Tips & Best Practices',
    icon: <BulbOutlined />,
    content: (
        <ul style={{ paddingLeft: 24, marginBottom: 0 }}>
            {tips.map((tip, index) => (
                <li key={index}>
                    <Typography>{tip}</Typography>
                </li>
            ))}
        </ul>
    ),
});
